import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
 
import { ToastrModule } from 'ngx-toastr';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProductsComponent } from './dashboard/products/products.component';
import { ProductComponent } from './dashboard/products/product/product.component';
import { ProductListComponent } from './dashboard/products/product-list/product-list.component';
import { SiteComponent } from './site/site.component';
import { DashHeaderComponent } from './dashboard/dash-header/dash-header.component';
import { DashFooterComponent } from './dashboard/dash-footer/dash-footer.component';
import { DashSidebarComponent } from './dashboard/dash-sidebar/dash-sidebar.component';
import { ProductService } from './dashboard/shared/product.service';
import { FormsModule } from "@angular/forms";
import { CategorysComponent } from './dashboard/categorys/categorys.component';
import { CategoryComponent } from './dashboard/categorys/category/category.component';
import { CategoryListComponent } from './dashboard/categorys/category-list/category-list.component';
import { CategoryService } from './dashboard/shared/category.service';
import { SubcategoryComponent } from './dashboard/categorys/subcategory/subcategory.component';
import { SubcategoryListComponent } from './dashboard/categorys/subcategory-list/subcategory-list.component';
import { StoresComponent } from './dashboard/stores/stores.component';
import { StoreComponent } from './dashboard/stores/store/store.component';
import { StoreListComponent } from './dashboard/stores/store-list/store-list.component';
import { PrivacyComponent } from './dashboard/privacy/privacy.component';
import { SupportComponent } from './dashboard/support/support.component';
import { LocationsComponent } from './dashboard/locations/locations.component';
import { LocationComponent } from './dashboard/locations/location/location.component';
import { LocationListComponent } from './dashboard/locations/location-list/location-list.component';
import { UsersComponent } from './dashboard/users/users.component';
import { UserComponent } from './dashboard/users/user/user.component';
import { UserListComponent } from './dashboard/users/user-list/user-list.component';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { LogoutComponent } from './logout/logout.component';

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    ProductsComponent,
    ProductComponent,
    ProductListComponent,
    SiteComponent,
    DashHeaderComponent,
    DashFooterComponent,
    DashSidebarComponent,
    CategorysComponent,
    CategoryComponent,
    CategoryListComponent,
    SubcategoryComponent,
    SubcategoryListComponent,
    StoresComponent,
    StoreComponent,
    StoreListComponent,
    PrivacyComponent,
    SupportComponent,
    LocationsComponent,
    LocationComponent,
    LocationListComponent,
    UsersComponent,
    UserComponent,
    UserListComponent,
    LogoutComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
     AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
     FormsModule,
     BrowserAnimationsModule,
     ToastrModule.forRoot()
  ],
  providers: [ProductService,CategoryService,
    AngularFireAuthModule],
  bootstrap: [AppComponent]
})
export class AppModule { }
